import { Core } from "@/core/Core";

export default {

  /* Supplements */

  async getSupplement(context, {inventoryId, id, version}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/supplements/${id}`, {version});
    } catch (e) {
      return null;
    }
  },

  async createSupplement(context, {inventoryId, data, version}) {
    try {
      let query = version ? `?version=${version}` : '';
      return await Core.request("POST", `/api/inventory/${inventoryId}/supplements${query}`, data);
    } catch (e) {
      return null;
    }
  },

  async saveSupplement(context, {inventoryId, supplementId, data, version}) {
    try {
      let query = version ? `?version=${version}` : '';
      return await Core.request("PUT", `/api/inventory/${inventoryId}/supplements/${supplementId}${query}`, data);
    } catch (e) {
      return null;
    }
  },

  async deleteSupplement(context, {inventoryId, supplementId}) {
    try {
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/supplements/" + supplementId);
    } catch(e) {
      return null;
    }
  }
}

